import * as React from 'react';
import { Props, propTypes } from './props';
import { Icon } from 'semantic-ui-react';

import './styles.css';

export default class CheckCellRenderer extends React.Component<Props> {
  static propTypes = propTypes;

  render() {
    const icon = this.props.value ? 'check circle' : 'x';
    const color = this.props.value ? 'green' : 'red';
    return (
      <Icon name={icon} color={color} className="check-cell-content" />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/check/component.tsx